/* TWWTS — Barra acquisto fissa su mobile. Clicca il pulsante originale, quindi usa il flusso Dawn. */
(function () {
  var page = document.querySelector('.twwts-product-page');
  if (!page) return;
  var mq = window.matchMedia('(max-width: 900px)');

  function mainBtn() { return page.querySelector('form[action$="/cart/add"] [name="add"]'); }
  function priceText() {
    var el = page.querySelector('[id^="price-"] .price-item--last') || page.querySelector('[id^="price-"] .price-item');
    return el ? el.textContent.trim() : '';
  }

  var titleEl = page.querySelector('.twwts-product-title');
  var bar = document.createElement('div');
  bar.className = 'twwts-satc';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = '<div class="twwts-satc__info"><p class="twwts-satc__title"></p><p class="twwts-satc__price"></p></div><button type="button" class="twwts-satc__btn" tabindex="-1"></button>';
  document.body.appendChild(bar);
  var bTitle = bar.querySelector('.twwts-satc__title');
  var bPrice = bar.querySelector('.twwts-satc__price');
  var bBtn = bar.querySelector('.twwts-satc__btn');
  bTitle.textContent = titleEl ? titleEl.textContent.trim() : '';

  function sync() {
    var b = mainBtn();
    if (!b) return;
    var label = b.querySelector('span') ? b.querySelector('span').textContent : b.textContent;
    bBtn.textContent = label.trim();
    bBtn.disabled = b.disabled || b.getAttribute('aria-disabled') === 'true';
    bPrice.textContent = priceText();
  }

  var ticking = false;
  function update() {
    ticking = false;
    var b = mainBtn();
    if (!b || !mq.matches) { hide(); return; }
    var r = b.getBoundingClientRect();
    var out = r.bottom < 0 || r.top > window.innerHeight;
    if (out) { sync(); show(); } else { hide(); }
  }
  function show() {
    if (bar.classList.contains('is-visible')) return;
    bar.classList.add('is-visible'); bar.removeAttribute('aria-hidden');
    bBtn.removeAttribute('tabindex'); document.body.classList.add('has-satc');
  }
  function hide() {
    if (!bar.classList.contains('is-visible')) return;
    bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden', 'true');
    bBtn.setAttribute('tabindex', '-1'); document.body.classList.remove('has-satc');
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  bBtn.addEventListener('click', function () {
    var b = mainBtn();
    if (b && !b.disabled) b.click();
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('change', function () { setTimeout(function () { sync(); update(); }, 400); });
  update();
})();
